import React, { createContext, useContext, useState, ReactNode } from 'react';

// Tipos de idiomas suportados
export type Language = 'pt' | 'en-US' | 'es-ES';

// Interface do contexto
interface LanguageContextType {
  selectedLanguage: Language;
  setLanguage: (language: Language) => void;
}

// Criar o contexto
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Provider Props
interface LanguageProviderProps {
  children: ReactNode;
}

// Provider do contexto
export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  // Inicializar com base no localStorage se existir
  const getInitialLanguage = (): Language => {
    try {
      const savedLang = localStorage.getItem('language');
      if (savedLang === 'pt-BR') return 'pt';
      if (savedLang === 'en-US') return 'en-US';
      if (savedLang === 'es') return 'es-ES';
    } catch (e) {
      console.log(e);
    }
    return 'pt'; // padrão
  };

  const [selectedLanguage, setSelectedLanguage] = useState<Language>(getInitialLanguage());

  const setLanguage = (language: Language) => {
    setSelectedLanguage(language);
  };

  return (
    <LanguageContext.Provider value={{ selectedLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook customizado para usar o contexto
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

